<template>
  <v-container class="text-center">
    <h4 class="mt-5">
      {{ $t('title.give_donation') }}
    </h4>
    <h2 class="my-3">
      {{ $amount(donationAmount.added) }}
    </h2>
    <span>pour</span>
    <h3>{{ campagne.Associations[0].Enseigne }}</h3>

    <img
      v-if="campagne.Associations[0].Logo !== null"
      :src="campagne.Associations[0].Logo"
      class="logo my-5"
      alt="asso-logo"
    >

    <div class="px-5 mt-5">
      <v-btn
        color="success"
        x-large
        block
        @click="valid"
      >
        Oui
      </v-btn>
    </div>

    <div class="pull-bottom bloc px-5 mb-5">
      <v-btn
        color="error"
        class="mb-5"
        outlined
        block
        @click="toPayment"
      >
        Non
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { $amount } from '@/modules/Utils'
import { TypeValeurEnum } from '@/modules/Enums'

export default {
  name: 'DonationView',

  props: {
    goToCashless: { type: Boolean, default: false }
  },

  computed: {
    donationAmount () {
      return this.calcAmount(
        this.$store.state.donationAmount + this.$store.state.amount,
        this.campagne.Rules[0]
      )
    },
    campagne () {
      return this.$store.getters.donationCampaign
    }
  },

  methods: {
    $amount,
    valid () {
      // S'il accepte de faire un don, on enregistre le montant du don
      this.$store.commit('donationAmount', this.donationAmount.added)
      // Puis on redirige vers le paiement CB
      this.toPayment()
    },

    toPayment () {
      this.$router.replace({ name: 'banking-payment', params: { goToCashless: this.goToCashless, directPayment: true } })
    },

    /**
     * Calcule le montant
     * Le tout en centimes
     * @return { Object }
     */
    calcAmount (amount, rule) {
      let reminder = 0
      let added = 0
      if (rule === undefined) {
        reminder = amount % 100
        return {
          amount: (amount - reminder) + 100,
          added: 100 - reminder
        }
      } else {
        switch (rule.TypeValeur) {
          case TypeValeurEnum.FIXE:
          case TypeValeurEnum.LIBRE:
            return {
              amount: amount + rule.Valeur,
              added: rule.Valeur
            }
          case TypeValeurEnum.ARRONDI:
            reminder = amount % 100
            return {
              amount: (amount - reminder) + 100,
              added: 100 - reminder
            }
          case TypeValeurEnum.POURCENTAGE:
            added = Math.ceil(amount * (rule.Valeur / 1000))
            return {
              amount: amount + added,
              added: added
            }
        }
      }
    }
  }
}
</script>

<style scoped>
.logo {
  max-height: 30vh;
  max-width: 80vw;
  margin: auto;
}
</style>
